import React from 'react';
import { Database, Plus, Users } from 'lucide-react';

// ── Tables ───────────────────────────────────────────────────────────────────
// Structured data Giga can read and write. Like tracks, every table belongs to a
// group, so access follows the group.
// ─────────────────────────────────────────────────────────────────────────────

const TABLES: {
  name: string;
  group: string;
  rows: number;
  columns: number;
  source: string;
  updated: string;
}[] = [{
  name: 'Creator Outreach',
  group: 'Giga Marketing',
  rows: 248,
  columns: 11,
  source: 'Notion',
  updated: '4m ago'
}, {
  name: 'Integration Coverage',
  group: 'Giga Master',
  rows: 96,
  columns: 8,
  source: 'Giga native',
  updated: '1h ago'
}, {
  name: 'Content Calendar',
  group: 'Giga Marketing',
  rows: 132,
  columns: 9,
  source: 'Airtable',
  updated: '2h ago'
}, {
  name: 'Waitlist Signups',
  group: 'Giga Master',
  rows: 4216,
  columns: 6,
  source: 'Google Sheets',
  updated: '12m ago'
}, {
  name: 'Ad Spend by Channel',
  group: 'Giga Marketing',
  rows: 74,
  columns: 12,
  source: 'Google Sheets',
  updated: 'Yesterday'
}, {
  name: 'Skills Backlog',
  group: 'Giga Master',
  rows: 61,
  columns: 7,
  source: 'Giga native',
  updated: '3d ago'
}];
export function TablesView() {
  return <div className="p-6 md:p-8" data-id="element-2457" data-mp="2n0os3mpo8mq3">
      <div className="flex flex-wrap items-center gap-3" data-id="element-2458" data-mp="2mzdlzg8r72vt">
        <h1 className="mr-auto text-[26px] font-bold text-neutral-900" data-id="element-2459" data-mp="2i0tyhbeihj1c">
          Tables
        </h1>
        <button type="button" className="flex items-center gap-1.5 rounded-lg bg-neutral-900 px-3 py-2 text-[13px] font-medium text-white transition-colors hover:bg-neutral-800" data-id="element-2460" data-mp="2dyz28lbftvuf">
          <Plus size={15} data-id="element-2461" data-mp="241aumusqgtuu" />
          New table
        </button>
      </div>

      <p className="mt-2 max-w-2xl text-[13.5px] leading-relaxed text-neutral-500" data-id="element-2462" data-mp="2435j2j37r43o">
        Structured data Giga can read and write — created here or synced from a
        connected tool. Tables belong to a group, so access follows the group.
      </p>

      <ul className="mt-5 grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3" data-id="element-2463" data-mp="1wpwfblj8b7yh">
        {TABLES.map(t => <li key={t.name} className="rounded-xl border border-neutral-200 bg-white p-4 transition-colors hover:border-neutral-300" data-id="element-2464" data-mp="21h4p4ioh0vc6">
            <div className="flex items-start gap-3" data-id="element-2465" data-mp="1mtjm0orliw49">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-teal-50 text-teal-700" data-id="element-2466" data-mp="1rqjwrcze4n1p">
                <Database size={16} data-id="element-2467" data-mp="2fhpc7r1f5dbh" />
              </span>
              <div className="min-w-0 flex-1" data-id="element-2468" data-mp="2kfqqzzrtaqh5">
                <p className="truncate text-[14.5px] font-semibold text-neutral-900" data-id="element-2469" data-mp="2kefqc8tnxyu9">
                  {t.name}
                </p>
                <p className="flex items-center gap-1.5 truncate text-[12.5px] text-neutral-500" data-id="element-2470" data-mp="25kkkzcspurnt">
                  <Users size={11} data-id="element-2471" data-mp="2ajnqszgit1wu" />
                  {t.group}
                </p>
              </div>
            </div>
            <div className="mt-3 flex items-baseline justify-between gap-3 border-t border-neutral-100 pt-3 text-[12.5px] text-neutral-500" data-id="element-2472" data-mp="z2e6kapki5uh">
              <span data-id="element-2473" data-mp="3d8vp17ce3yt1">
                <span className="font-semibold text-neutral-900" data-id="element-2474" data-mp="3d8c73qmqpaf0">
                  {t.rows.toLocaleString('en-US')}
                </span>{' '}
                rows · {t.columns} columns
              </span>
              <span data-id="element-2475" data-mp="3m8r43n92gdyc">{t.source}</span>
            </div>
            <p className="mt-1 text-[12px] text-neutral-400" data-id="element-2476" data-mp="3i903ysxnglh5">
              Updated {t.updated}
            </p>
          </li>)}
      </ul>
    </div>;
}